import { get } from 'lodash'

export default function(fields = {}, profile) {
  const newAddress = {
    line1: get(fields, 'line1'),
    line2: get(fields, 'line2'),
    stateOrProvinceOrRegion: get(fields, 'stateOrProvinceOrRegion'),
    city: get(fields, 'city'),
    zipCode: get(fields, 'zipCode'),
    countryId: get(fields, 'countryId'),
    country: { id: get(fields, 'countryId') },
  }

  return {
    ...profile,
    secondaryEmail: get(fields, 'secondaryEmail'),
    tertiaryEmail: get(fields, 'tertiaryEmail'),

    title: get(fields, 'title'),
    firstName: get(fields, 'firstName'),
    middleName: get(fields, 'middleName'),
    lastName: get(fields, 'lastName'),

    phone: get(fields, 'phone'),
    phoneType: get(fields, 'phoneType'),
    secondaryPhone:
      get(fields, 'secondaryPhone') && get(fields, 'secondaryPhone') !== '+'
        ? get(fields, 'secondaryPhone')
        : '',
    secondaryPhoneType: get(fields, 'secondaryPhoneType'),
    birthDate: get(fields, 'birthDate'),

    ...newAddress,
    address: {
      ...get(profile, 'address'),
      ...newAddress,
    },

    helpers: undefined,
    file: undefined,
    assessorDetail: {
      ...fields.assessorDetail,
      childProtectionExpirationDate: get(
        fields,
        'assessorDetail.childProtectionExpirationDate'
      ),
      childProtectionNumber: get(fields, 'assessorDetail.childProtectionNumber')
    }
  }
}
